<script lang="ts">
	import { selectedClientStore } from '../../../../api/EnzianDataApi';
	import IconButton from '../../../../basic/buttons/IconButton.svelte';
	import DefaultSimpleList from '../../../../basic/list/DefaultSimpleList.svelte';
	import Searchbar from '../../../../basic/search/Searchbar.svelte';
	import { createSettingDocumentTypesStore } from '../../../../stores/SettingDocumentTypeStore.svelte';
	import type { SettingDocumentType } from '../../../../types/BasicTypes';
	import { onDestroy } from 'svelte';
	import { _ } from 'svelte-i18n';
	import ListItemSettingDocumentType from '../settingdocumenttypes/ListItemSettingDocumentType.svelte';
	import PatchSettingDocumentType from '../settingdocumenttypes/PatchSettingDocumentType.svelte';
	import CreateSettingDocumentType from './CreateSettingDocumentType.svelte';

	interface Props {
		showDetailOnClick?: boolean;
		onSelectionChanged?: (item: SettingDocumentType) => void;
	}

	let { showDetailOnClick = true, onSelectionChanged }: Props = $props();

	let settingDocumentTypeStore = $state(createSettingDocumentTypesStore());

	let showCreate = $state(false);
	let targetDocumentType: SettingDocumentType | undefined = $state();

	//Add reactivity for client change
	let unSubscribe = selectedClientStore.subscribe((client) => {
		if (client == null) return;
		settingDocumentTypeStore.applyFilter();
	});

	onDestroy(() => {
		unSubscribe();
	});
</script>

<div class="h-full overflow-y-auto pt-8">
	<!--Add the list of document types-->
	<div class="h-full grid grid-rows-[auto_1fr]">
		<div class="items-center flex pb-9 pl-8 gap-8">
			<Searchbar
				onSearchTrigger={() => {
					settingDocumentTypeStore.applyFilter();
				}}
				placeholder={$_('settings.basic.document_labels.lbl_hint')}
				bind:filter={settingDocumentTypeStore.listFilter}
			/>
			<IconButton
				iconName="plus"
				hoverText={$_('settings.basic.document_labels.lbl_add')}
				primary={true}
				onClick={() => {
					showCreate = true;
				}}
			/>
		</div>

		<DefaultSimpleList
			bind:store={settingDocumentTypeStore}
			onAddRequest={() => {
				showCreate = true;
			}}
			onEditRequest={(item) => {
				targetDocumentType = item as SettingDocumentType;
			}}
			onSelectionChanged={(item) => {
				if (showDetailOnClick) {
					targetDocumentType = item as SettingDocumentType;
				}
				onSelectionChanged?.(item as SettingDocumentType);
			}}
			itemComponent={ListItemSettingDocumentType}
		/>
	</div>

	{#if showCreate}
		<CreateSettingDocumentType
			onModalClose={() => {
				showCreate = false;
			}}
			createSettingDocumentType={settingDocumentTypeStore.createSettingDocumentTypeStore}
		/>
	{/if}

	{#if targetDocumentType}
		<PatchSettingDocumentType
			onModalClose={() => {
				targetDocumentType = undefined;
			}}
			{targetDocumentType}
			patchSettingDocumentType={settingDocumentTypeStore.patchSettingDocumentTypeStore}
		/>
	{/if}
</div>
